
//remove all except for cells and required delimiters
export class Cleaner {

  private readonly isEditor: (node: Node) => boolean;
  private readonly isDelimiter: (node: Node) => boolean;
  private readonly isAllowedTag:(node:Node)=>boolean;
  private readonly isBreak:(node:Node)=>boolean;

  constructor(isEditor: (node: Node) => boolean, isDelimiter: (node: Node) => boolean, isAllowedTag:(node:Node)=>boolean,isBreak:(node:Node)=>boolean) {
    this.isDelimiter = isDelimiter;
    this.isEditor = isEditor;
    this.isAllowedTag = isAllowedTag;
    this.isBreak = isBreak;
  }

  clean(element: Element): void {
    const toRemove: Node[] = [];
    const delims: HTMLSpanElement[] = [];
    this.gatherNonEditorElements(element, toRemove, delims);
    this.remove(toRemove);

    //Remove non required delims. Keep only those who has editor OR break at left
    //And those who has nothing at left and editor at right. I believe this will keep 1 delimiter between editor cells
    //And one before the first cell and one after the last cell.

    const keptDelims: HTMLSpanElement[] = [];

    for (const delim of delims) {
      let remove = false;
      const prevSibling = delim.previousSibling;
      if (!prevSibling) {
        const nextSibling = delim.nextSibling;
        if (nextSibling == null || !this.isEditorOrBreak(nextSibling)) {
          remove = true;
        }
      } else if (!this.isEditorOrBreak(prevSibling)) {

        remove = true;
      }

      if (remove) {
        delim.remove();
      }
      else {
        keptDelims.push(delim);
      }
    }

    //Вот был у меня разделитель после редактора
    //Я вставил после него пробел
    //Теперь разделитель не нужен. Но он остается!!!
    //надо потом еще раз пройти и удалить все разделители, имеющие в соседях тексты

    for (const delim of keptDelims) {
      if (this.isVisibleNonCellAndNonBr(delim.previousSibling) || this.isVisibleNonCell(delim.nextSibling)) {
        delim.remove();
      }
    }


  }

  private isEditorOrBreak(node:Node): boolean {
    return this.isEditor(node) || this.isBreak(node);
  }

  private isVisibleNonCell(n: Node | null): boolean {
    if (n) {
      return !this.isEditor(n) && !this.isDelimiter(n);
    }
    else {
      return false;
    }
  }

  private isVisibleNonCellAndNonBr(n: Node | null): boolean {
    if (n) {
      return !this.isEditor(n) && !this.isDelimiter(n) && !this.isBreak(n);
    }
    else {
      return false;
    }
  }

  private gatherNonEditorElements(
    element: Element,
    toRemove: Node[],
    delims: HTMLSpanElement[]
  ): void {
    for (let i = 0; i < element.childNodes.length; i++) {
      const child = element.childNodes.item(i);
      if (child && child.nodeType == Node.ELEMENT_NODE) {
        const el = child as Element;


        //remove all tags except for editor cells and those delimiters that has no valid children
        if (!this.isEditor(el) &&
          (!this.isDelimiter(el) || this.hasNonEmptyChild(el))&&
          (!this.isAllowedTag(el))) {
          toRemove.push(el);
          this.gatherNonEditorElements(el, toRemove, delims);
        }
        if (this.isDelimiter(el) && el.childNodes.length == 0) {
          delims.push(el as HTMLSpanElement);
        }
      }
      if (child && child.nodeType == Node.TEXT_NODE) {
        if (!child.textContent || child.textContent.length == 0) {
          toRemove.push(child);
        }
      }
    }
  }
  private hasNonEmptyChild(el: Element): boolean {
    for (let i = 0; i < el.childNodes.length; i++) {
      const child = el.childNodes.item(i);
      if (child.textContent && child.textContent.length > 0) {
        return true;
      }
    }
    return false;
  }

  private remove(toRemove: Node[]): void {
    while (true) {
      const el = toRemove.pop();
      if (el) {
        const parent = el.parentElement;
        if (parent) {
          const allChildren: Node[] = [];
          for (let j = 0; j < el.childNodes.length; j++) {
            const sc = el.childNodes.item(j);
            allChildren.push(sc);
          }
          for (const sc of allChildren) {
            parent.insertBefore(sc, el);
          }
          parent.removeChild(el);
        }
      } else {
        break;
      }
    }
  }
}